import { Link } from 'react-router-dom';

export default function CompetitorGrid() {
  const competitors = [
    {
      name: 'Astoria Ford',
      location: 'Astoria, OR',
      link: '/vs/astoria-ford',
      image: 'https://images.unsplash.com/photo-1562141961-4c5f0c6b6c8a?w=400&h=300&fit=crop&q=80',
      facts: [
        'Ford vehicles only',
        'Traditional dealership model',
        'Single-location inventory'
      ]
    },
    {
      name: 'Lums Toyota',
      location: 'Warrenton, OR',
      link: '/vs/lums-toyota',
      image: 'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=400&h=300&fit=crop&q=80',
      facts: [
        'Toyota vehicles only',
        'Traditional dealership model',
        'Single-location inventory'
      ]
    },
    {
      name: 'Oceancrest Chevrolet',
      location: 'Warrenton, OR',
      link: '/vs/oceancrest-chevrolet',
      image: 'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=400&h=300&fit=crop&q=80',
      facts: [
        'Chevrolet vehicles only',
        'Traditional dealership model',
        'Single-location inventory'
      ]
    },
    {
      name: 'Warrenton Kia',
      location: 'Warrenton, OR',
      link: '/vs/warrenton-kia',
      image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400&h=300&fit=crop&q=80',
      facts: [
        'Kia vehicles only',
        'Traditional dealership model',
        'Single-location inventory'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Understand Your Options Before You Buy
          </h2>
          <p className="text-xl text-gray-600">
            Compare local dealerships side-by-side to find the right fit for your needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {competitors.map((competitor) => (
            <Link
              key={competitor.name}
              to={competitor.link}
              className="bg-gray-50 rounded-xl p-6 border-2 border-gray-200 hover:border-teal-500 hover:shadow-xl transition group"
            >
              <div className="text-center mb-4">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition">
                  {competitor.name}
                </h3>
                <p className="text-sm text-gray-600">{competitor.location}</p>
              </div>

              <div className="space-y-3 mb-4">
                {competitor.facts.map((fact, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <i className="ri-information-line text-slate-500 mt-1"></i>
                    <span className="text-sm text-gray-700">{fact}</span>
                  </div>
                ))}
              </div>

              <div className="pt-4 border-t border-gray-300">
                <div className="flex items-center justify-center gap-2 text-teal-600 font-semibold group-hover:gap-3 transition-all whitespace-nowrap">
                  Learn More
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="inline-block bg-teal-50 border-2 border-teal-500 rounded-xl p-8">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-check-circle-fill text-4xl text-teal-600"></i>
              <h3 className="text-2xl font-bold text-gray-900">Rockhound Auto</h3>
            </div>
            <p className="text-gray-600 mb-4 max-w-md mx-auto">
              We source from the entire dealer network — giving you access to every make, model, and trim level.
            </p>
            <div className="space-y-2 text-left max-w-md mx-auto">
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Access to every make and model</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Transparent, itemized pricing</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">No-pressure buying experience</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-teal-600"></i>
                <span className="text-gray-700">Fair market trade-in values</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}